import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const PolicyEN = ({ user, onAcknowledge }) => {
  const navigate = useNavigate();
  const [ackSubmitting, setAckSubmitting] = useState(false);
  const langBtnStyle = { backgroundColor: '#e3f2fd', color: '#1565c0', border: '1px solid #90caf9', padding: '8px 16px', borderRadius: '6px', textDecoration: 'none', fontWeight: 500, display: 'inline-block' };

  const handleAcknowledge = async () => {
    if (!user || !onAcknowledge) return;
    setAckSubmitting(true);
    try {
      await onAcknowledge();
      navigate('/', { replace: true });
    } finally {
      setAckSubmitting(false);
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <div className="card">
        <div style={{ marginBottom: '20px' }}>
          <Link to="/policy/cn" style={langBtnStyle}>中文版</Link>
        </div>
        <h1>Course Enrollment Agreement (English)</h1>
        <p style={{ color: '#666', marginBottom: '30px' }}>Last updated: {new Date().toLocaleDateString(undefined, { timeZone: 'America/Los_Angeles' })}</p>

        <section style={{ marginBottom: '30px' }}>
          <p>Please read the following terms carefully before enrolling in any course.</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>1. Validity Period</h2>
          <p>Each 4-session package must be completed within 6 weeks from the start date. Any unused sessions after the validity period will be automatically forfeited.</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>2. Leave & Rescheduling Policy</h2>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>Students must notify the instructor at least 24 hours in advance if they need to reschedule. Otherwise, the session will be counted as attended.</li>
            <li>Each package allows a maximum of one (1) rescheduled session, which must be completed within the validity period.</li>
          </ul>
          <h3 style={{ marginTop: '20px' }}>Temporary Sick Leave</h3>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>In case of a sudden illness occurring shortly before class, students must notify the instructor as soon as possible. In such cases, half (0.5) session credit will be retained. This policy may only be applied once per package and cannot be accumulated.</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>3. Refund Policy</h2>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>A full refund is available if requested at least 7 days (one week) before the course start date.</li>
            <li>No refunds will be issued once the course has started.</li>
            <li>After the course begins, unused sessions may be transferred to another person or postponed to the next package (one-time only).</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>4. Schedule Adjustment After Course Begins</h2>
          <p>If a schedule adjustment is needed after the course begins, students must contact the instructor in advance. All changes are subject to availability and instructor approval.</p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2>5. Additional Information</h2>
          <ul style={{ marginLeft: '20px', marginTop: '10px' }}>
            <li>This studio offers small-group instruction. To ensure teaching quality, students are expected to follow the agreed schedule and all course policies.</li>
            <li>In the event of special circumstances, students are encouraged to communicate with the instructor in a timely manner. The instructor will make reasonable efforts to provide an appropriate solution, subject to studio policies and availability.</li>
          </ul>
        </section>

        <div style={{ marginTop: '40px', paddingTop: '20px', borderTop: '1px solid #ddd', display: 'flex', gap: '12px', flexWrap: 'wrap', alignItems: 'center' }}>
          {user && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleAcknowledge}
              disabled={ackSubmitting || user.policy_acknowledged_at}
            >
              {user.policy_acknowledged_at ? 'Policy acknowledged' : ackSubmitting ? 'Saving…' : 'I have read and acknowledge the policy'}
            </button>
          )}
          <Link to="/register" className="btn btn-secondary">Back to Registration</Link>
        </div>
      </div>
    </div>
  );
};

export default PolicyEN;
